import React from 'react'

export default function BrandLogo({img}) {
  return (
    <div>
      <img src={img} alt='' style={{width:'40px'}}/>
    </div>
  )
}
